import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { DropdownOption } from "../../../models/DropdownOption";

export default function Dropdown(props: {
    options: DropdownOption<any>[];
    onChange: (value: DropdownOption<any>) => void;
    selectedOption: DropdownOption<any> | undefined;
    disabled?: boolean;
}) {
    const { t } = useTranslation();

    return (
        <Menu as="div" className="relative">
            <Menu.Button disabled={props.disabled} className="inline-flex ml-auto justify-between w-40 gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                {props.selectedOption ? props.selectedOption.label : t('select')}
                <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" />
            </Menu.Button>

            <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in">
                <div className="py-1">
                    {props.options.map((option, index) => (
                        <Menu.Item key={index}>
                            <button className="block px-4 py-2 w-full text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" onClick={() => props.onChange(option)}>
                                {option.label}
                            </button>
                        </Menu.Item>
                    ))}
                </div>
            </Menu.Items>
        </Menu>
    )
}